<template>
  <i-checkbox
    :checked="selected"
    @update:checked="(checked, event) => $emit('select', event.shiftKey, checked)"
    :aria-label="LANG.checkboxDefaultAriaLabel"
  />
</template>

<script>
import { defineComponent } from 'vue';
import { mapState } from 'vuex';

export default defineComponent({
  inheritAttrs: false,
  props: {
    selected: Boolean,
  },
  computed: {
    ...mapState(['LANG']),
  },
});
</script>

<style scoped lang='scss'>
</style>
